import React, { useEffect } from 'react';
import useDataStore from "../../../stores/useDataStore";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const { allUsers, getAllUsers, updateUserRole, loading, error } = useDataStore();
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'en';

  useEffect(() => {
    getAllUsers();
  }, [getAllUsers]);

  const handleMakeAdmin = async (userId) => {
    await updateUserRole(userId, "admin");
    getAllUsers();
  };

  return (
    <div className="p-4 sm:p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Dashboard</h1>
      </div>

      {loading ? (
        <div className="text-gray-500">Loading users...</div>
      ) : error ? (
        <div className="text-red-500">Error: {error}</div>
      ) : (
        <div className="bg-gray-100 rounded-md mx-4 sm:mx-6 lg:mx-0 overflow-hidden">
          {/* Header */}
          <div className="hidden lg:grid grid-cols-5 bg-gray-200 text-gray-700 font-bold px-6 py-2">
            <span>First Name</span>
            <span>Last Name</span>
            <span>Role</span>
            <span>Email</span>
            <span>Action</span>
          </div>

          {/* Users */}
          {Array.isArray(allUsers) && allUsers.map((user) => (
            <div
              key={user._id}
              className="border-t border-gray-100 px-6 
                         py-6 sm:py-6 lg:py-4 hover:bg-gray-50
                         flex flex-col gap-2 lg:grid lg:grid-cols-5 lg:items-center lg:gap-0 bg-white"
            >
              {/* Mobile view with labels */}
              <div className="lg:hidden">
                <span className="font-semibold">First Name: </span>{user.firstName}
              </div>
              <div className="lg:hidden">
                <span className="font-semibold">Last Name: </span>{user.lastName}
              </div>
              <div className="lg:hidden">
                <span className="font-semibold">Role: </span>{user.role || "user"}
              </div>
              <div className="lg:hidden">
                <span className="font-semibold">Email: </span>{user.email}
              </div>
              <div className="lg:hidden">
                {user.role !== "admin" && (
                  <button
                    className="bg-[#0b5ed7] text-white px-3 py-1 rounded-md hover:bg-blue-600 mt-2"
                    onClick={() => handleMakeAdmin(user._id)}
                  >
                    Make Admin
                  </button>
                )}
              </div>

              {/* Desktop grid view */}
              <span className="hidden lg:block">{user.firstName}</span>
              <span className="hidden lg:block">{user.lastName}</span>
              <span className="hidden lg:block">{user.role || "user"}</span>
              <span className="hidden lg:block">{user.email}</span>
              <span className="hidden lg:block">
                {user.role !== "admin" && (
                  <button
                    className="bg-[#0b5ed7] text-white px-3 py-1 rounded-md hover:bg-blue-600"
                    onClick={() => handleMakeAdmin(user._id)}
                  >
                    Make Admin
                  </button>
                )}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashboard;






